import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import { useDel } from 'hooks';
import { exportTemplate } from 'services/api';
import { exportTemplateActions as actions } from 'reducers/exportTemplate/reducer';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { errorResToMessageArray } from './errorResToMessageArray';

export const useDeleteTemplateMutation = (
  _onRequestSuccess,
  _onRequestError
) => {
  const dispatch = useDispatch();

  const onRequestError = useCallback(
    res => {
      notification.open({
        icon: <CloseCircleOutlined style={{ fontSize: 20, color: 'red' }} />,
        message: 'Error',
        description: (
          <div>
            Failed to delete template.
            {errorResToMessageArray(res).map(err => (
              <p key={err} style={{ fontSize: 12, color: '#666' }}>
                {err}
              </p>
            ))}
          </div>
        ),
        placement: 'bottomLeft',
        duration: 8, // Seconds
      });
      _onRequestError?.();
    },
    [_onRequestError]
  );

  const onRequestSuccess = useCallback(() => {
    dispatch(actions.serverMutationOccurred());
    notification.open({
      icon: <CheckCircleOutlined style={{ fontSize: 20, color: 'green' }} />,
      message: 'Success',
      description: 'Template deleted successfully',
      placement: 'bottomLeft',
    });
    _onRequestSuccess?.();
  }, [_onRequestSuccess, dispatch]);

  const [{ loading: deleteLoading }, deleteTemplate] = useDel({
    configuration: {
      onRequestSuccess,
      onRequestError,
    },
  });

  const triggerDelete = templateId => {
    deleteTemplate({ url: exportTemplate(templateId) });
  };

  return {
    triggerDelete,
    deleteLoading,
  };
};
